import {
  IBankRequisites,
  IContactApplication,
} from "../../slice/applicationDataToBankSlice/applicationDataToBankSlice";
export interface AccountingBalance {
  balance_date_lc: string;
  balance_date_rc: string;
  data: {
    [key: string]: {
      rc: number;
      ls: number;
    };
  }[];
  osn: boolean;
  usn_income: boolean;
  usn_income_expenses: boolean;
  envd: boolean;
  patent: boolean;
  simplified_form: boolean;
  full_form_balance_opiu: boolean;
}
export interface IChangeApplicationDataToBank {
  applicationId: number;
  applicationBankId: number;
  contactApplication?: Partial<IContactApplication>;
  bankRequisites?: Partial<IBankRequisites>;
  accountingBalance?: AccountingBalance;
}

export enum SetApplicationBankStatusResponse {
  return_from_reject = "revision",
  resigning = "re-signing-first-stage",
}

export interface IChangeApplicationBankStatusErrorResponse {
  message?: string;
  success?: boolean;
}
